import { Ajax } from './../Core/Ajax';
import { Constants } from './../Core/Constants';
import { Storage } from './../Core/Storage';
import { AppStore } from './../Core/AppStore';
import { CalculatedCart } from './../Models/CalculatedCart';

export class CartProvider {

	static loadCartFromServer() {
		///to do
	}

	static getProductUtmSource(productId) {
		let productsUtmSource = Storage.instance().productsUtmSource ?? [];
		return productsUtmSource.find(pus => pus.productId == productId)?.utmSource;
	}

	static calculateCart(callBack) {
		if (Storage.instance().cart.cartedProducts.length >= 0) {
			var cart = {
				CartedProducts: Storage.instance().cart.cartedProducts,
                Coupon: Storage.instance().cart.coupon
			};
			cart.CartedProducts.forEach((cp) => {
				cp.utmSource = cp.utmSource || CartProvider.getProductUtmSource(cp.productId);
			});

			Ajax.post(Constants.Url.CalculateCart, cart,
				function (data) {
					console.log('CartProvider.calculateCart', data);

					//zkontroluji košík, že obsahuje všechna data
					var cart = Storage.instance().cart;
					//zaktualizuji košík dle toho co přijde pro případy, že některe položky nejsou aktivni
					cart.cartedProducts = [];
					data.cartedProducts.forEach((item) => {
						cart.cartedProducts.push({
							product: item.product,
							productId: item.product.id,
							count: item.count,
							utmSource: item.utmSource || CartProvider.getProductUtmSource(item.product.id)
						});
					});
					if (data.coupon && !data.coupon.isValid) {//new coupon applied
                        data.message = data.coupon?.validationMsg;
					}
					cart.coupon = data.coupon?.isValid ? data.coupon : null;
					data.coupon = cart.coupon;

					Storage.instance().cart = cart;
					Storage.instance().cachedCart = data;

					var productsCategory = Storage.instance().productsCategory ?? [];
					var missedProductsCategoryIds = cart.cartedProducts.map(cp => cp.productId).filter(pid => !productsCategory.some(pc => pc.productId == pid))
					if (missedProductsCategoryIds?.length) {
						Ajax.post(Constants.Url.GetProductsCategory, { Ids: missedProductsCategoryIds },
							function (productCategoriesResult) {
								var productsCategory = Storage.instance().productsCategory ?? [];
								productsCategory.push(...productCategoriesResult);
								Storage.instance().productsCategory = productsCategory;
								console.log(productsCategory);

								window.gtm.onCartUpdate(data);
								if (callBack) callBack(Storage.instance().cachedCart);
								notify(data);
							});
					}
					else {
						window.gtm.onCartUpdate(data);
						if (callBack) callBack(Storage.instance().cachedCart);
						notify(data);
					}
				});
		}
		else { //prazdny kosik nebudu posilat
			var emptyCart = CartProvider.getEmptyCalculatedCart();
			if (Storage.instance().isAuthorized()) {
				Ajax.post(Constants.Url.ClearCart, null,
					function () {

						notify(emptyCart);
					});
			}
			else {
				notify(emptyCart);
			}
			if (callBack) callBack(emptyCart);
		}

		function notify(cart) {
			AppStore.emit('Cart.AfterUpdate');
		}
	}

	static getCount = (items) => {
		let count = 0;
		items.forEach((item) => {
			count = count + item.count;
		});
		return count;
	}

	static getEmptyCalculatedCart() {
		var cart = new CalculatedCart();
		cart.currencyId = Storage.instance().currencyId;
		cart.countryId = Storage.instance().countryId;
		return cart;

	}

	static clear() {
		CartProvider.clearLocalStorage(false);
		CartProvider.calculateCart();
	}

	static addOrderToCart(order, callback) {
		var cart = Storage.instance().cart;
		order.orderedProducts.forEach((orderedProduct) => {
			if (orderedProduct.product) {
				var existItem = cart.cartedProducts.find(function (item) {
					return item.productId == orderedProduct.product.id;
				});
				if (existItem) {
					existItem.count = existItem.count + orderedProduct.count;
				}
				else {
					existItem = {
                        product: orderedProduct.product,
						productId: orderedProduct.product.id,
						count: orderedProduct.count,
						utmSource: orderedProduct.utmSource || CartProvider.getProductUtmSource(orderedProduct.product.id)
					};
					cart.cartedProducts.push(existItem);
				}
			}
		});
		Storage.instance().cart = cart;
		CartProvider.calculateCart();
		if (callback)
			callback();
	}

	static validateCart(callBack) {
		var cart = Storage.instance().cart;
		var cachedCart = Storage.instance().cachedCart;
		if ((!cart || !cart.cartedProducts || cart.cartedProducts.length == 0) && cachedCart && cachedCart.cartedProducts && cachedCart.cartedProducts.length > 0)
		{
			Storage.instance().cachedCart = null;
			cachedCart = null;
			CartProvider.calculateCart();
		}
		var loadCart =  (cart && cart.cartedProducts.length > 0 && (!cachedCart || !cachedCart.cartedProducts || CartProvider.getCount(cachedCart.cartedProducts) != CartProvider.getCount(cart.cartedProducts)));
		if (loadCart) {
			console.log("cart will recalculate ");
			CartProvider.calculateCart(callBack);
		}
		else {
			console.log("cart from cash ");
			if (callBack) callBack(cachedCart);
		}
	}

	static clearLocalStorage() {
		var cart = Storage.instance().cart;
		cart.cartedProducts = [];
		cart.remarks = null;
		var customer = Storage.instance().customer;
		if (customer) {
			customer.remarks = '';
		}
		Storage.instance().cart = cart;
	}
	static changeItem(item, newCount) {
		var add = newCount - item.count;
		if (add > 0) {
			window.gtm.onAddCartAction(item, '', 0, add);
		}
		else {
			window.gtm.onRemoveCartAction(item, Math.abs(add));
		}
		if (newCount <= 0) {
			CartProvider.removeItem(item);
		}
		else {
			var cart = Storage.instance().cart;
			var findItem = CartProvider.findItem(cart, item);
			findItem.count = newCount;
			Storage.instance().cart = cart;
			CartProvider.calculateCart();
		}
	}

	static clearAfterSubmit() {
		CartProvider.clearLocalStorage(true);
		CartProvider.calculateCart();
	}

	static removeItem(item) {
		var cart = Storage.instance().cart;
		var index = CartProvider.findItemIndex(cart, item);
		cart.cartedProducts.splice(index, 1);
		Storage.instance().cart = cart;
		window.gtm.onRemoveCartAction(item, item.count);
		CartProvider.calculateCart();
	}


	static addCoupon(code) {
		var cart = Storage.instance().cart;
		cart.coupon = { code: code };
		Storage.instance().cart = cart;
		CartProvider.calculateCart((cachedCart) => {
			if (Storage.instance().cart.coupon) {
				AppStore.emit('Cart.CouponAdded', Storage.instance().cart.coupon);
			}
			else if (cachedCart.message) {
				alert(cachedCart.message);
			}
		});
	}

	static removeCoupon() {
		var cart = Storage.instance().cart;
		cart.coupon = null;
		Storage.instance().cart = cart;
		CartProvider.calculateCart();
	}

	static findItem(cart, findItem) {
		return cart.cartedProducts.find((item) => {
			return (item.productId == findItem.product.id);
		});
	}

	static findItemIndex(cart, findItem) {
		return cart.cartedProducts.findIndex((item) => {
			return (item.productId == findItem.product.id);
		});
	}

	static addItem(product, add, callBack, gtmIgnore) {

		var cart = Storage.instance().cart;

		var existItem = cart.cartedProducts.find(function (item) {
			return item.productId == product.id;
		});
		if (existItem != null) {

			var c = parseInt(existItem.count) + parseInt(add);
			if (c < 0) c = 0;
			if (c > 0) {
				existItem.count = c;

			}
			else {
				const index = cart.cartedProducts.indexOf(existItem);
				cart.cartedProducts.splice(index, 1);
			}
		}
		else {
			var cartItem = {
                product: product,
				productId: product.id,
				count: add,
				utmSource: CartProvider.getProductUtmSource(product.id)
			};
			cart.cartedProducts.push(cartItem);
		}
		Storage.instance().cart = cart;
		CartProvider.calculateCart(callBack);		
	}

	static getCart() {

		var cart = Storage.instance().cart;
		return cart;
	}

	
}
